/* eslint-disable react/no-array-index-key */
import React, {
  useState, Fragment,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { QUANTITY } from '@Apis/constants';
import {
  Table, Select,
  notification,
  message,
  Divider,
  Checkbox,
  Button,
} from 'antd';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import H3Text from '@Uilib/h3Text';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleQuestion,
} from '@fortawesome/free-solid-svg-icons';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import PRZModal from '../../../../Common/UI/PRZModal';
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;
const RfqLines = ({
  loading, selectedRfq, MONEY, updateRfqParticipant, callback, setRfqLineData, rfqLineData,
}) => {
  const [showPRZModal, setShowPRZModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const getOptionLabel = (option) => {
    const { children } = option.props;
    return React.Children.toArray(children)
      .map((child) => {
        if (typeof child === 'string') {
          return child;
        } if (typeof child.props?.children === 'string') {
          return child.props.children;
        }
        return '';
      })
      .join(' ');
  };
  const getColumns = () => {
    const columns = [
      {
        title: 'SKU#',
        width: '250px',
        render: (record) => (
          <Fragment>
            <div onClick={() => { setShowPRZModal(true); setSelectedDocumentId(record?.product_sku_info?.product_sku_id); }}>
                <a>
                  {`#${record?.product_sku_info?.internal_sku_code}`}
                </a>
              </div>
            {record?.product_sku_info?.product_category_info?.category_path?.length > 0 && (
            <ProductCategoryLabel
                categoryPath={record?.product_sku_info?.product_category_info?.category_path}
                categoryName={record?.product_sku_info?.product_category_info?.category_path?.at(
                  -1
                )}
                containerStyle={{
                  width: "fit-content",
                }}
              />
            )}
            <H3Text text={`${record?.product_sku_info?.ref_product_code ? `${record?.product_sku_info?.ref_product_code} - ` : ''}${record?.product_sku_info?.product_sku_name}`?.trim()} className="" />
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Quantity',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <div style={{ whiteSpace: 'nowrap' }}>{`${QUANTITY(item?.quantity, item?.uom_info?.precision)} ${item?.uom_info?.uqc?.toProperCase() || ''}`}</div>,
      },
      {
        title: 'Participants',
        width: '200px',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => {
          const selectedParticipantsIds = record?.rfq_participant_ids?.length > 0 ? record.rfq_participant_ids.filter(id => id !== null) : [];
          return (
            <div className="rfq-line__questions-wrapper">
              <PRZSelect
                mode="tags"
                placeholder="Select participants"
                maxTagCount="responsive"
                value={selectedParticipantsIds}
                onChange={(value) => {
                  const copyData = JSON.parse(JSON.stringify(rfqLineData));
                  for (let i = 0; i < copyData?.length; i++) {
                    if (copyData[i]?.rfq_line_id === record?.rfq_line_id) {
                      copyData[i].rfq_participant_ids = value;
                    }
                  }
                  setRfqLineData(copyData);
                }}
                showSearch
                filterOption={(input, option) => getOptionLabel(option).toLowerCase().indexOf(input.toLowerCase()) >= 0}
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    <Divider style={{ margin: '4px 0' }} />
                    <Button
                      type="primary"
                      ghost
                      style={{ width: '100%', textAlign: 'center' }}
                      onClick={() => {
                        const payload = {
                          rfq_id: selectedRfq?.rfq_id,
                          rfq_line_id: record?.rfq_line_id,
                          action: 'SAVE_PARTICIPANT',
                          line_rfq_participant_ids: selectedParticipantsIds,
                        };
                        if (selectedRfq?.status === 'DRAFT') {
                          updateRfqParticipant([payload], () => {
                            callback();
                          });
                        } else {
                          notification.open({
                            type: 'error',
                            message: 'You are not allowed to update after draft stage',
                            duration: 4,
                            placement: 'top',
                          });
                        }
                      }}
                    >
                      Save
                    </Button>
                  </div>
                )}
              >
                {selectedRfq?.rfq_participants?.map((participant) => (
                  <Option
                    key={participant.seller_id}
                    value={participant.rfq_participant_id}
                    disabled={selectedRfq?.status !== 'DRAFT'}
                    style={{ backgroundColor: 'transparent', outline: 'none' }}
                  >
                    <Checkbox
                      checked={selectedParticipantsIds?.includes(participant.rfq_participant_id)}
                      disabled={selectedRfq?.status !== 'DRAFT'}
                      onChange={(e) => {
                        const value = e.target.checked
                          ? [...selectedParticipantsIds, participant.rfq_participant_id]
                          : selectedParticipantsIds?.filter((id) => id !== participant.rfq_participant_id);
                        const copyData = JSON.parse(JSON.stringify(rfqLineData));
                        for (let i = 0; i < copyData?.length; i++) {
                          if (copyData[i]?.rfq_line_id === record?.rfq_line_id) {
                            copyData[i].rfq_participant_ids = value;
                          }
                        }
                        setRfqLineData(copyData);
                      }}
                    >
                      {participant.participant_name}
                    </Checkbox>
                  </Option>
                ))}
              </PRZSelect>
            </div>
          );
        },
      },
      {
        title: 'Delivery Location',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => `${record?.delivery_tenant_info?.tenant_name || '-'}`,
      },
      {
        title: 'Questions',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <div className="rfq-line__questions-wrapper">
            {record?.rfq_line_questions?.map((ques, index) => (
              <div key={index} className="flex-display flex-align-c">
                <div className="rfq-line__question">
                  <FontAwesomeIcon icon={faCircleQuestion} style={{ marginTop: '3px' }} />
                  &nbsp;
                  <div key={index}>{ques?.question}</div>
                </div>
              </div>
            ))}
          </div>
        ),
      },
    ];

    if (selectedRfq?.status === 'COMPLETED') {
      columns.splice(2, 0, {
        title: 'Purchased',
        width: '100px',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => <div style={{ whiteSpace: 'nowrap' }}>{`${QUANTITY(item?.purchase_quantity, item?.uom_info?.precision)} ${item?.uom_info?.uqc?.toProperCase() || ''}`}</div>,
      });
    }

    return columns;
  };

  return (
    <Fragment>
      <div className="view-rfq-lines__wrapper">
        <div className="view-rfq-lines__body-wrapper">
          <Table
            bordered
            loading={loading}
            showHeader
            size="small"
            columns={getColumns()}
            dataSource={rfqLineData}
            pagination={false}
            scroll={{ x: 'max-content' }}
          />
        </div>
      </div>
      <PRZModal
        isOpen={showPRZModal}
        onClose={() => {
          setShowPRZModal(false);
          setSelectedDocumentId(null);
        }}
        entityType="product"
        documentId={selectedDocumentId}
      />
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, RfqReducers,
}) => ({
  user: UserReducers.user,
  createRfqLoading: RfqReducers.createRfqLoading,
  updateRfqLoading: RfqReducers.updateRfqLoading,
  getRfqByIdLoading: RfqReducers.getRfqByIdLoading,
  updateRfqParticipantLoading: RfqReducers.updateRfqParticipantLoading,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
  updateRfqParticipant: (payload, callback) => dispatch(RfqActions.updateRfqParticipant(payload, callback)),
  getRfqById: (orgId, tenantId, rfqId, callback) => dispatch(RfqActions.getRfqById(orgId, tenantId, rfqId, callback)),
});

RfqLines.propTypes = {
  user: PropTypes.any,
  rfqLineData: PropTypes.any,
  selectedRfq: PropTypes.any,
  loading: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RfqLines));
